module.exports = __webpack_public_path__ + "img/breadcrumb-personal.64d68d85.png";